import React, 
       { useState, 
         useContext, 
         useEffect }        from 'react';
import { Navbar, 
         Nav,
         Dropdown}          from 'react-bootstrap';
import { Link }             from 'react-router-dom';
import api                  from './AxiosConfig';
import { AuthContext }      from './AuthContext';
import { useNavigate }      from 'react-router-dom';
import LoginModal           from './LoginModal';
import LogoutModal          from './LogoutModal';
import ChangePasswordModal  from './ChangePasswordModal';
import { FaUserCircle }     from 'react-icons/fa';
import DaysUntil90          from './DaysUntil90';
import { SelectionContext } from './SelectionContext';
import SystemMessage        from './SystemMessage';

function Navigation( ) {
    const { isLoggedIn, 
            isAdmin, 
            lastDismissed }                                         = useContext(AuthContext);
    const { enableOrderEdit, 
            getSysMessageDismissed,
            setSysMessageDismissed }                                = useContext(SelectionContext);
    const [registerEnable,            setRegisterEnable]            = useState(false);
    const [systemMessage,             setSystemMessage]             = useState("");
    const [systemMessageActive,       setSystemMessageActive]       = useState(false);
    const [systemMessagePreLogin,     setSystemMessagePreLogin]     = useState(false);
    const [systemMessageSerial,       setSystemMessageSerial]       = useState( 1 ) ;
    const [isLoginModalOpen,          setIsLoginModalOpen]          = useState(false);
    const [isLogoutModalOpen,         setIsLogoutModalOpen]         = useState(false);
    const [prevLoginState,            setPrevLoginState]            = useState(false);
    const [isChangePasswordModalOpen, setIsChangePasswordModalOpen] = useState(false); 
    const navigate                                                  = useNavigate();

    const openLoginModal = () => {
        setIsLoginModalOpen(true);
    };

    const closeLoginModal = ( success ) => {
       setIsLoginModalOpen(false);
       if ( success ) {
           navigate('/status', {  });     
       }
    };

    const openLogoutModal = () => {
        setIsLogoutModalOpen(true);
    };

    const closeLogoutModal = () => {
       setIsLogoutModalOpen(false);
    };

    const openChangePasswordModal = () => {
       setIsChangePasswordModalOpen(true);
    };

    const closeChangePasswordModal = () => {
       setIsChangePasswordModalOpen(false);
    };

    const editDisplayStatus = () => {
        enableOrderEdit();
    }

    const dismissMessage = async () => {
        await api.put('site/users/dismiss-system-message', {}, {withCredentials: true } );  
        setSysMessageDismissed( true );
    }
       
    useEffect(() => {
           console.log("Status change: isLoggedIn=" + isLoggedIn );
           if ( isLoggedIn ) {
               if ( !prevLoginState ) {
                   console.log("Disable login dialogue.");
                      setIsLoginModalOpen( false );
               }
           } else { 
               if( prevLoginState ) {
                   console.log("Force login dialogue.");
                   setIsLoginModalOpen( true );
               } 
           }
           setPrevLoginState( isLoggedIn );             
    },[isLoggedIn]);
              
    useEffect(() => {
        // Fetch status and admin options only once on mount
        async function getAdminOpts() {
            try {
                const response = await api.get('/site/admin-options', {withCredentials: true });
                if (response.status === 201) {
                    const adminOptions = response.data.adminOptions;
                    for ( let opt = 0; opt < adminOptions.length ; opt++ ){
                        if ( adminOptions[opt].key === "registerEnabled" ) {
                            if (adminOptions[opt].value === "yes" ) {
                                setRegisterEnable(true);
                            } else {
                                setRegisterEnable(false);
                            }
                        }
                        if (adminOptions[opt].key === "systemMessageSerial") {
                            setSystemMessageSerial( Number(adminOptions[opt].value));
                        }
                        if (adminOptions[opt].key === "systemMessage" ) {
                            setSystemMessage( adminOptions[opt].value);
                        }
                        if (adminOptions[opt].key === "systemMessageActive" ) {
                            if (adminOptions[opt].value === "yes") {
                                setSystemMessageActive( true );
                            } else {
                                setSystemMessageActive( false );
                            };
                        }
                        if (adminOptions[opt].key === "systemMessagePreLogin" ) {
                            if (adminOptions[opt].value === "yes") {
                                setSystemMessagePreLogin( true );
                            } else {
                                setSystemMessagePreLogin( false );
                            };
                        }
                    }
                }
            } catch (error) {
                console.log("Error " + error);
            }
        }

        getAdminOpts();
    }, []); // Empty dependency array means this effect runs only once when the component mounts

return (
  <>
    <Navbar bg="dark" variant="dark" expand="lg">
      <Navbar.Brand href="#">Goal Tracker</Navbar.Brand>
      <Nav className="me-auto">
        {isLoggedIn && isAdmin && (
              <Dropdown>
                <Dropdown.Toggle as={Nav.Link} className="d-flex align-items-center" style={{ cursor: 'pointer' }}>
                  Admin
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item as={Link} to="/admin-options">Options</Dropdown.Item>
                  <Dropdown.Item as={Link} to="/admin-users">Users</Dropdown.Item>
                  <Dropdown.Item as={Link} to="/admin-system">System</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>               
        )}
        {isLoggedIn ? (
          <>
             <Nav.Link as={Link} to="/status">
                Status
              </Nav.Link>
             <Nav.Link as={Link} to="/add-goal">
                Add Goal
              </Nav.Link>
              {/* Profile Dropdown */}
              <Dropdown align="end">
                <Dropdown.Toggle as={Nav.Link} className="d-flex align-items-center" style={{ cursor: 'pointer' }}>
                  <FaUserCircle size={24} />
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <Dropdown.Item onClick={openChangePasswordModal}>Change Password</Dropdown.Item>
                  <Dropdown.Item as={Link} to="/profile">Edit Profile</Dropdown.Item>
                  <Dropdown.Item onClick={editDisplayStatus}>Edit Status Positions</Dropdown.Item>
                  <Dropdown.Item onClick={openLogoutModal}>Log Out</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
          </>
        ) : (
          <>
            <Nav.Link onClick={openLoginModal}>
              Log In
            </Nav.Link>
            {registerEnable && (
              <Nav.Link as={Link} to="/signup">
                Sign Up
              </Nav.Link>
            )}
          </>
        )}
      </Nav>
      { isLoggedIn && (
      <Nav className="ms-auto">
        <div className="nav-link days-till-90">
            <DaysUntil90 />
        </div>
      </Nav> )}
    </Navbar>
    { ( systemMessagePreLogin || isLoggedIn ) && systemMessageActive && ( lastDismissed < systemMessageSerial ) && !getSysMessageDismissed() && ( <SystemMessage message={systemMessage} closeMessage={dismissMessage}/> ) }
    <LoginModal  isOpen={isLoginModalOpen} onClose={closeLoginModal} />
    <LogoutModal isOpen={isLogoutModalOpen} onClose={closeLogoutModal} />
    <ChangePasswordModal isOpen={isChangePasswordModalOpen} onClose={closeChangePasswordModal} />
  </>
);

}

export default Navigation;
